/**
 * /formation-125-progression — Trame pédagogique complète Formation 125 (7 h).
 * Utilisable en salle (théorie), plateau (technique) et circulation (application).
 */
import React from 'react';
import TrameProgression from '../components/trames/TrameProgression';
import TrameLivretCross from '../components/trames/TrameLivretCross';
import { INTRO_125, PHASES_125, buildSynthese125 } from '../data/formation125Progression';

export default function Formation125Progression() {
  return (
    <>
      <TrameLivretCross
        current="trame"
        trameTo="/formation-125-progression"
        trameLabel="Trame pédagogique Formation 125"
        livretTo="/livret-125"
        livretLabel="Livret Formation 125 interactif"
      />
      <TrameProgression
        testid="formation-125-progression"
        trameKey="125"
        title="Formation 125 — Une journée pour comprendre, maîtriser et circuler"
        subtitle="Progression pédagogique adaptée au niveau et à l’expérience du conducteur. La théorie s’adapte, les exercices techniques s’enchaînent, la circulation intervient uniquement quand le niveau le permet."
        badge="Trame pédagogique Formation 125"
        breadcrumbLabel="Formation 125 · 7 h"
        intro={INTRO_125}
        phases={PHASES_125}
        buildSynthese={buildSynthese125}
      />
    </>
  );
}
